const config = {
  orgName: 'fcc',
  useArticleSummary: false,
}

export default config